// extracted by mini-css-extract-plugin
export default {"button":"WordSelectionCheckBoxList_button__rQBHl"};